import React, { FC } from 'react';
import { Button } from '@material-ui/core';
import { Trans } from 'react-i18next';

import { Loaders } from 'components';

interface IProps {
  i18nKey: string;
  disabled?: boolean;
  working?: boolean;
}

const PostButton: FC<IProps> = ({ working, disabled, i18nKey, ...props }) => {
  if (working) {
    return <Loaders.Standard height={38} />;
  }

  return (
    <Button
      fullWidth
      type="submit"
      size="large"
      variant="contained"
      color="primary"
      disabled={disabled}
      {...props}>
      <Trans i18nKey={i18nKey} />
    </Button>
  );
};

PostButton.defaultProps = {
  working: false,
  disabled: false,
};

export default PostButton;
